import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Tag } from "@design-system/Tag/Tag";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { HStack } from "@design-system/HStack/HStack";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

export const CloseTemplateNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, string>) => (
        <ViewTableCell>
            <HStack as="span" align="center" gap={8}>
                <span>{row.original.name}</span>
                {row.original.archivedAt != null && (
                    <Tag color="neutral" size="sm">
                        Archived
                    </Tag>
                )}
            </HStack>
        </ViewTableCell>
    ),
);
